import { FC } from "react";
import { NetworkPortfolioManagementMembership } from "@app/network-portfolio-management/interfaces";
import { formatAccuracyBandPercent } from "@app/shared/utility/formatAccuracyBandPercent";

interface AccuracyOverviewProps {
  membership: NetworkPortfolioManagementMembership | null;
  projectId: number;
}

type AccuracyPercentField =
  | "accuracyAccuratePercent"
  | "accuracyInaccuratePercent"
  | "accuracySuspectPercent"
  | "accuracyEnrichedPercent"
  | "accuracySkippedPercent";

// Display order is fixed by design: Accurate, Inaccurate, Suspect, Enriched, Skipped. Do not reorder.
const STATUS_CELLS: { key: AccuracyPercentField; label: string; colorModifier: string }[] = [
  { colorModifier: "accurate", key: "accuracyAccuratePercent", label: "Accurate" },
  { colorModifier: "inaccurate", key: "accuracyInaccuratePercent", label: "Inaccurate" },
  { colorModifier: "suspect", key: "accuracySuspectPercent", label: "Suspect" },
  { colorModifier: "enriched", key: "accuracyEnrichedPercent", label: "Enriched" },
  { colorModifier: "skipped", key: "accuracySkippedPercent", label: "Skipped" },
];

export const AccuracyOverview: FC<AccuracyOverviewProps> = ({ membership, projectId }) => (
  <section
    className="network-portfolio-management-project-card__accuracy-overview"
    data-testid={`network-portfolio-management-card-accuracy-overview-${projectId}`}
    aria-labelledby={`accuracy-overview-section-label-${projectId}`}
  >
    <span id={`accuracy-overview-section-label-${projectId}`} className="network-portfolio-management-project-card__accuracy-overview-label">
      Accuracy Overview
    </span>
    <div className="network-portfolio-management-project-card__accuracy-overview-row">
      {STATUS_CELLS.map(({ key, label, colorModifier }) => (
        <div
          key={key}
          className="network-portfolio-management-project-card__accuracy-overview-cell"
          data-testid={`network-portfolio-management-card-accuracy-overview-cell-${projectId}-${colorModifier}`}
        >
          <span className="network-portfolio-management-project-card__accuracy-overview-status-label">{label}</span>
          <span
            className={`network-portfolio-management-project-card__accuracy-overview-percent network-portfolio-management-project-card__accuracy-overview-percent--${colorModifier}`}
          >
            {formatAccuracyBandPercent(membership?.[key])}
          </span>
        </div>
      ))}
    </div>
  </section>
);
